import { ProductType } from '@/types';

export const getViewByPerspective = (productType: ProductType, perspectiveId: string) =>
  productType.views.find(({ perspective }) => perspective === perspectiveId);
